// Регистрация общего service worker с отдельным scope для каждой студии.
// Один файл /sw.js, но у каждой студии своя регистрация, свои кэши и своя установка.

export function tenantScope(slug: string): string {
  return `/s/${slug}/`;
}

export async function registerTenantWorker(slug: string): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator) || !import.meta.env.PROD) return null;
  try {
    return await navigator.serviceWorker.register('/sw.js', { scope: tenantScope(slug), type: 'classic' });
  } catch {
    return null;
  }
}

export async function tenantRegistration(slug: string): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) return null;
  const reg = await navigator.serviceWorker.getRegistration(tenantScope(slug));
  return reg ?? (await registerTenantWorker(slug));
}

export function isStandalone(): boolean {
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

export function isIos(): boolean {
  const ua = navigator.userAgent;
  return /iPad|iPhone|iPod/.test(ua) || (ua.includes('Macintosh') && navigator.maxTouchPoints > 1);
}
